module.exports = __webpack_public_path__ + "static/media/new-post.8979a364.png";